import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import PropTypes from "prop-types";
import "./PlaceholderEmptyScreen.scss";

const PlaceholderEmptyScreen = (
    {
        headerText,
        textBeforeLink,
        buttonText,
        textAfterLink,
        bottomImage,
        altImageText,
        onClick
    }) => {

    const header = <h4 className="screen-header">{headerText}</h4>
    const mainText =
        <div className="screen-body-content">
            {textBeforeLink}
            <button onClick={onClick} className="inline-link">
                {buttonText}
            </button>
            {textAfterLink}
        </div>

    return (
        <React.Fragment>
            <Container className="placeholder-empty-screen">
                <Row>
                    <Col>
                        <Row style={{justifyContent:"center"}}>
                            {header}
                        </Row>
                        <Row style={{justifyContent:"center", marginBottom: "32px"}}>
                            {mainText}
                        </Row>
                        <Row style={{justifyContent:"center"}}>
                            <div className="image-container">
                                <img className="bottom-image" src={bottomImage} alt={altImageText}></img>
                            </div>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
}

PlaceholderEmptyScreen.propTypes = {
    headerText: PropTypes.string,
    textBeforeLink: PropTypes.string,
    buttonText: PropTypes.string,
    textAfterLink: PropTypes.string,
    bottomImage: PropTypes.any,
    altImageText: PropTypes.string,
    onClick: PropTypes.func
}

export default PlaceholderEmptyScreen;